<template>
  <div class="privacy-doc">
    <p>
      <strong>大众签章平台产品服务隐私政策</strong>
    </p>
    <p>&nbsp;</p>
    <p>
      发布时间：
      <strong>2021年 1 月 28 日</strong>
    </p>
    <p>
      生效时间：
      <strong>2021年 1 月 28 日</strong>
    </p>
    <p>欢迎您使用山东国盾网信息科技有限公司的大众签章平台（以下简称&ldquo;大众签章&rdquo;或&ldquo;我们&rdquo;）的服务！本政策适用于我们提供的产品和服务，包括电子签名产品、存证服务、法律服务等。</p>
    <p>我们希望通过本隐私政策向您说明我们在您使用&ldquo;大众签章&rdquo;的产品服务时如何收集、使用、保存、共享和转让、公开您的个人信息及对这些信息的保护。请您在使用&ldquo;大众签章&rdquo;的产品服务前仔细阅读并确认您已经充分理解本政策所写明的内容，一旦您开始使用&ldquo;大众签章&rdquo;产品服务，即表示您已充分理解并同意本政策，并同意我们按照本隐私政策（含更新版本）收集、使用、保存和共享、转让、公开您的相关信息。如果您不同意本政策的条款，应停止使用相关服务。</p>
    <p>本隐私政策将帮助您了解以下内容：</p>
    <p>一、我们如何收集您的个人信息；</p>
    <p>二、我们如何使用您的个人信息；</p>
    <p>三、我们如何共享、转让、公开您的个人信息；</p>
    <p>四、我们如何使用Cookies技术；</p>
    <p>五、我们如何存储和保护您的个人信息；</p>
    <p>六、您个人信息的管理；</p>
    <p>七、未成年人个人信息保护；</p>
    <p>八、免责声明；</p>
    <p>九、联系我们；</p>
    <p>十、隐私政策的变更和修订。</p>
    <p>&nbsp;</p>
    <p>
      <strong>一、我们如何收集您的个人信息</strong>
    </p>
    <p>基于合法、正当、必要的原则，我们收集为实现产品功能所需要的信息，并将收集信息进行合理使用。我们会收集以下个人或企业信息：</p>
    <p>（一）您在注册、使用我们服务时提供的信息</p>
    <p>
      1&nbsp;&nbsp;&nbsp;&nbsp;
      为便于我们提供服务，您在注册或开通服务时需要提供包括真实姓名、个人电话号码、地址个人身份信息。如您进行身份认证服务，我们会收集您的真实姓名、身份证(含证件照)、手机号码、银行卡信息以及其他由您提供的认证信息。如您是法人单位，我们还会收集您的公司营业执照或组织机构代码证信息（含扫描件）、法定代表人实名信息（含姓名及有效证件号码等）、经办人实名信息（含姓名，有效证件号码等）、公司住所地、公司电话号码及公司对公银行账号等您提供的认证信息。注：收集此类信息是为了满足相关法律法规的实名要求，若您不提供此类信息，您将无法完成实名认证，亦无法以实名身份签发文件。
    </p>
    <p>（二）您在使用过程中提供的信息</p>
    <p>我们会收集您主动上传至我们的材料，包含合同原文、哈希值或其他书面材料，该文件或材料可能涉及您的隐私信息或商业秘密。我们会对上述信息进行安全保存。除非您主动提交合同审阅的服务，我们不会主动收集或分析这些信息。若您提供的是他人的信息，包括姓名、电话号码、身份证号、收件地址、邮箱地址等个人隐私信息，您需确认获得对方授权且保证对方也知晓并同意受本隐私协议之约束，因您提供的信息造成他人损害的，将由您自行承担责任。同时，如果他人提出相反意见或者向我们明示不愿受本隐私协议约束的，我们将删除相关信息。此外，为了保障我们服务的连续性及您的账户安全，我们会收集您的下述信息：</p>
    <p>2.1 设备信息：设备型号、操作系统版本、唯一设备标识符、IP 地址信息。</p>
    <p>1）相机/摄像头权限：用于提供拍照上传附件、人脸识别认证、刷脸签署等服务，权限的获得需要您的授权同意。上述权限为相关功能的必要权限，拒绝大众签章使用该权限将影响您使用相关功能。</p>
    <p>2）相册权限：用于提供头像上传、图片附件上传、签署附件上传等服务，权限的获得需要您的授权同意。上述权限为相关功能的必要权限，拒绝大众签章使用该权限将影响您使用相关功能。</p>
    <p>3）通讯录权限：用于提供添加通讯录好友、添加外部签署方等服务；权限的获得需要您的授权同意。上述权限为相关功能的必要权限，拒绝大众签章使用该权限将影响您使用相关功能。</p>
    <p>4）手机录音权限：用于个人身份认证时进行语音活体检测；权限的获得需要您的授权同意。该权限为相关功能的必要权限，拒绝大众签章使用该权限将影响您使用相关功能。</p>
    <p>2.2 软件信息：软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需（调用其他APP用于认证服务），我们会收集有关您使用的移动应用和其他软件的信息。</p>
    <p>2.3 服务日志信息。您在使用我们服务时登录时间、操作内容及时间、服务故障信息等信息。</p>
    <p>2.4 IP及位置信息。例如，我们可能会通过IP地址、GPS、WiFi或基站等途径获取您的地理位置信息。</p>
    <p>2.5如果您使用我们的客服系统，我们将收集您的手机号、邮箱和以及您反馈的信息，用于与您取得联系和解决问题。</p>
    <p>2.6数字证书信息：在基于您的实名认证信息后，我们会为您申请数字证书，并保留您的数字证书信息，此信息包含您的姓名、身份证号或企业实名信息，以及为您申请的数字证书序列号，方便您在使用签署服务时调用。</p>
    <p>2.7 存证信息：您在使用我们服务时我们会获取您主动上传至我方的文件或本平台其他渠道存证的文件信息，我们会对这些信息进行加密存储，并且不会分析该类信息。</p>
    <p>
      2.8
      授权信息：如果您需要提供他人信息时，您需确保获得信息主体授权且保证其也愿意接受本隐私政策之约束，因为您提供的信息造成他人损害的，将由您承担责任。如果信息主体提出异议，我们将删除相关信息。
    </p>
    <p>&nbsp;</p>
    <p>（三）第三方为实现签约目的提供给我们的信息</p>
    <p>在获取您明确同意的情况下，我们会与大众签章的合作客户共享您的个人信息，如您授权大众签章的合作客户将您的姓名、身份证号、手机号码、邮箱地址、签署完成的电子文件共享至大众签章平台，您可以在本平台上查看、下载本平台上的信息或文件。</p>
    <p>（四）其他信息</p>
    <p>本隐私协议列明的内容并不能完整罗列并覆盖未来可能实现的所有功能和业务场景，我们将基于本政策未载明的其他特定目的收集您的信息，但会事先征求您的同意。</p>
    <p>&nbsp;</p>
    <p>（五）征得授权同意的例外</p>
    <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
    <p>5.1与国家安全、国防安全有关的；</p>
    <p>5.2与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>5.3与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>5.4出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p>5.5所收集的个人信息是您自行向社会公众公开的；</p>
    <p>5.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>5.7根据您的要求签订合同所必需的或双方已在合同中另行约定的；</p>
    <p>5.8用于维护所提供的产品或服务的安全稳定运行所必需的，例如处理产品或服务的故障；</p>
    <p>5.9学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>5.10法律法规规定的其他情形。</p>
    <p>&nbsp;</p>
    <p>
      <strong>二、我们如何使用您的个人信息</strong>
    </p>
    <p>我们将严格遵守法律法规及与您的约定，将收集到的信息进行如下使用：</p>
    <p>（一）帮助您成为我们的会员；</p>
    <p>（二）向您提供产品和服务，包括依托第三方完成的实名认证、存证、出证等服务的合理使用；</p>
    <p>（三）产品开发和服务优化；</p>
    <p>（四）其他用途：当我们要将信息用于本政策未载明的其他用途或要将基于特定目的收集的信息用于其他目的时，会事先征求您的同意。</p>
    <p>您的信息将会存储在大众签章的服务器上。为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于用户研究分析与统计等服务，但我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。</p>
    <p>&nbsp;</p>
    <p>
      <strong>三、我们如何共享、转让、公开披露您的个人信息</strong>
    </p>
    <p>我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
    <p>（一）共享</p>
    <p>1.1我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
    <p>
      1.2与合作机构共享:
      为实现服务目的，我们的某些服务将由我们和合作机构共同提供。我们会根据法律法规与合作伙伴共享您的某些个人信息。您的个人身份信息及签约信息可能会传输至电子认证服务机构(简称CA)、公证处、司法鉴定中心、区块链、互联网法院、仲裁委、第三方身份认证机构等，由上述权威机构出具相应证明文件或处理案件等目的使用并保存。我们仅会出于合法、正当、必要的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
    </p>
    <p>1.3为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于用户研究分析与统计等服务。</p>
    <p>1.4为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息或将所收集到的信息用于大数据分析，例如，您应用程序的频率、故障信息、总体使用情况、性能数据或分析形成不包含任何个人信息的城市热力图或行业洞察报告等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。</p>
    <p>
      1.5
      我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
      <span @click="gosdkdoc" class="herf-span">接入第三方SDK目录</span>
    </p>
    <p>
      <strong>（二）转让</strong>
    </p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1、在获取您明确同意的情况下转让。</p>
    <p>2、在大众签章及所属或关联公司发生合并、收购、资产转让、破产清算或其他类似情形时，如涉及到个人信息转让，我们会要求新持有您个人信息的公司、组织和个人继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
    <p>
      <strong>（三）公开披露</strong>
    </p>
    <p>我们仅会在以下情况下，公开披露您的信息：</p>
    <p>1、在您明确同意的披露方式下披露您所指定的信息。</p>
    <p>2、在法律法规、行政执法或司法要求等强制性要求下，我们可能会依据所要求的信息类型和披露方式披露您的信息。</p>
    <p>3、法律法规规定的其他情形。</p>
    <p>
      <strong>（四）例外情况</strong>
    </p>
    <p>以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1、与国家安全、国防安全直接相关的。</p>
    <p>2、与公共安全、公共卫生、重大公共利益直接相关的。</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
    <p>4、 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。</p>
    <p>5、您自行向社会公众公开的个人信息。</p>
    <p>6、 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p>
      <strong>四、我们如何使用Cookies技术</strong>
    </p>
    <p>
      在您使用我们的产品或服务时，我们的平台会自动接收并记录您的浏览器和计算机上的信息，其中包括您的 IP
      地址，您生成的电子签章，软硬件特征信息、以及您需求的网页记录，Cookies中的信息等。我们使用Cookies储存您访问我们网站的相关数据，在您访问或再次访问我们的网站时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。我们不会将
      Cookies
      用于本隐私政策所述目的之外的任何用途。您有权选择接受或拒绝接受Cookies。您可以通过修改浏览器的设置以拒绝接受Cookies，但是我们需要提醒您，因为您拒绝接受Cookies，您可能无法使用依赖于Cookies的部分功能，例如您每一次访问服务，之前所记录的相应信息均会被删除。
    </p>
    <p>
      <strong>五、我们如何存储和保护您的个人信息</strong>
    </p>
    <p>
      <strong>（一）信息存储</strong>
    </p>
    <p>（一）我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。若为处理跨境业务，确需向境外机构传输境内收集的相关个人信息的，我们会按照法律、行政法规和相关监管部门的规定执行。我们会确保您的个人信息得到足够的保护，例如匿名化、安全存储等。</p>
    <p>（二）我们仅在本政策所属目的所必须期间和法律法规要求的时限内存储您的个人信息，根据《电子签名法》规定，我们会保存您的个人信息至少五年。</p>
    <p>（三）但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
    <p>3.1 为遵守适用的法律法规等有关规定；</p>
    <p>3.2 为遵守法院判决、裁定或其他法律程序的规定；</p>
    <p>3.3 为遵守相关政府机关或法定授权组织的要求；</p>
    <p>3.4 我们有理由确信需要遵守法律法规等有关规定；</p>
    <p>3.5 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
    <p>（四）如我们停止运营&ldquo;大众签章&rdquo;的产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们存储的个人信息进行删除或匿名化处理。</p>
    <p>&nbsp;</p>
    <p>
      <strong>（二）信息保护</strong>
    </p>
    <p>我们将采取以下手段保护您的信息：</p>
    <ul>
      <li>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护条款，要求其按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</li>
      <li>为了保障您的信息安全，我们在收集您的信息后，将采取各种隔离必要的措施保护您的信息。我们会将去标识化后的信息与可用于恢复识别个人的信息分开存储，确保在针对去标识化信息的后续处理中不重新识别个人。</li>
      <li>我们承诺我们将使信息安全保护达到业界领先的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。在传输和存储个人敏感信息（含个人生物识别信息）时，我们将采用安全、权限控制、去标识化等安全措施。同时我们对数据采取了备份和恢复技术，在数据丢失的情况下及时恢复。</li>
      <li>在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。</li>
    </ul>
    <p>&nbsp;</p>
    <p>
      <strong>六、您个人信息的管理</strong>
    </p>
    <p>您具有管理个人信息的权利，包括对于您个人信息的访问、更正、删除等操作。</p>
    <p>
      <strong>（一） 访问</strong>
    </p>
    <p>
      您可以通过访问
      <strong>www.oaexpert.com</strong>来查阅、编辑您账户中的个人信息、更改您的密码、添加安全信息等。
    </p>
    <p>
      <strong>（二）更正</strong>
    </p>
    <p>当您发现收集、存储的个人信息有误，您可以根据自身实际情况或联系客服进行更正或删除。</p>
    <p>
      <strong>（三） 删除</strong>
    </p>
    <p>1、以下情况发生时，您有权要求&ldquo;大众签章&rdquo;删除您的个人信息：</p>
    <p>（1）我们没有征求您的明确同意，收集了您的个人信息。</p>
    <p>（2）我们处理您的个人信息违反了法律法规要求。</p>
    <p>（3）我们违反了与您的约定来收集、使用和处理您的个人信息。</p>
    <p>（4）您注销了&ldquo;大众签章&rdquo;帐号、卸载或者不再使用我们的产品（或服务）。</p>
    <p>（5）我们停止对您提供服务。</p>
    <p>2、删除的例外</p>
    <p>基于业务的需要，为维护交易多方的利益，在前述删除条款第（4）和（5）点的情形下，我们仍将保留您与业务直接关联的个人信息直至该业务保存期限到期。如您仍想删除此部分信息，需您与业务全部相关方授权同意，我们在收到您与业务全部相关方共同的删除指令后，会将该业务涉及的您的个人信息进行删除。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并避免任何进一步处理，直到备份可以清除或实现匿名。</p>
    <p>
      <strong>（四）注销</strong>
    </p>
    <p>如您需要注销您的账号，即不再使用我们的产品服务时，您可以自行或联系客服申请注销您的账户。大众签章在核实用户真实意愿后，7个工作日内为用户完成账号注销，账号注销后大众签章将不再为用户提供服务。</p>
    <p>
      <strong>七、未成年人信息的保护</strong>
    </p>
    <p>我们的产品服务对象主要为成年人，如您未满18周岁，如果没有父母或监护人的同意，不得创建自己的用户账户。请您的父母或法定监护人仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
    <p>我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。</p>
    <p>
      <strong>八、免责声明</strong>
    </p>
    <p>（一）&ldquo;大众签章&rdquo;可能含有其他网站的链接，我们可能在任何需要的时候增加商业伙伴或共用品牌的网站。&ldquo;大众签章&rdquo;对您通过&ldquo;大众签章&rdquo;链接到其他网站或地址需要的隐私保护不负任何责任。</p>
    <p>（二）因您个人原因导致账号密码泄露从而导致个人信息泄露的，&ldquo;大众签章&rdquo;不负任何责任，但我们会积极地配合您找回密码或更改密码。</p>
    <p>（三）您账号下关联的企业单位信息发生变更时，必须同步更新大众签章平台的相关企业信息及印章信息等信息。如您单位信息发生变更，大众签章平台未进行变更，您在大众签章平台任何操作产生的后果，大众签章平台将不负任何责任。</p>
    <p>
      <strong>九、联系我们</strong>
    </p>
    <p>
      请通过访问
      <strong>www.oaexpert.com</strong>在线客服系统或拨打我们的客服电话
      <strong>（0531-82860005）</strong>等方式与我们联系，我们将及时对您的问题进行受理并处理。
    </p>
    <p>
      <strong>十、隐私政策的变更和修订</strong>
    </p>
    <p>为了给您提供更好的服务，我们会适时变更、修订本政策内容。我们会通过在大众签章网站、移动端上推送系统通知或其他方式提醒您本政策的更新，也请您及时访问大众签章官网或客户端以便了解最新的隐私政策。</p>
    <p>
      注：本隐私政策如有更新，我们会及时提示您，如您继续使用我们的产品服务，即意味着您依然同意更新后的隐私政策内容，并且同意我们继续按照本隐私政策收集、使用、保存和共享您的相关信息。
      如果您不同意更新后的隐私政策内容，应停止使用相关服务。
    </p>
    <p>&nbsp;</p>
    <div class="backbtn" v-if="$route.query.type">
      <van-button type="info" @click="$router.go(-1)">返回</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacyProtocol',
  data() {
    return {
      screenWidth: '',
      screenHeight: ''
    }
  },
  mounted() {
    // var w = window.screen.width
    // this.screenWidth = document.body.clientWidth
    // this.screenHeight = document.body.clientHeight
    // window.onresize = () => {
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth
    //     this.screenHeight = document.body.clientHeight
    //     var d = document.getElementById('privacyProtocol')
    //     d.style.width = this.screenWidth + 'px'
    //     d.style.height = this.screenHeight + 'px'
    //   })()
    // }
  },
  methods: {
    gosdkdoc() {
      // this.$router.push({ name: 'SdkDoc' })
      try {
        let { href } = this.$router.resolve({ name: 'SdkDoc' })
        console.log('href', href);
        window.open(href, '_blank')
      } catch (error) {
        this.$router.push({ name: 'SdkDoc' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.privacyProtocol {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  white-space: pre-wrap;
  /*white-space : pre-line;*/
  background: rgba(243, 246, 247, 1);
}
.privacy-doc {
  text-align: left;
  padding-bottom: 40px;
  strong {
    font-weight: bold;
  }
  .herf-span {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }

  .backbtn {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: white;
    text-align: center;
    button {
      width: 100%;
    }
  }
}
</style>
